// extracted by mini-css-extract-plugin
module.exports =  {"chips":"o0ZYciGF_1LHAH25SVwA"};